export default __webpack_public_path__ + "static/media/Birds_of_Paradise_homo_logo_text.18d41528.png";